module.exports = __webpack_public_path__ + "img/NL410.ab301a0b.svg";